import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import ArrowRightIcon from '@wix/da-ds/pkg/Icons/16x16/ArrowRight';
import ResaleIcon from '@wix/da-ds/pkg/Icons/16x16/Resale';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { pushExclusiveTransactionHistoryModal } from '../../../../../../Modals/redux/actionCreators';
import { useBatchedCallback } from '@wix/da-hooks/pkg/useBatchedCallback';
const TradeCount = (_param)=>{
    var { deviation, count, onClick } = _param, rest = _object_without_properties(_param, [
        "deviation",
        "count",
        "onClick"
    ]);
    const { t } = useTranslation();
    const dispatchPushExclusiveTransactionHistoryModal = useAction(pushExclusiveTransactionHistoryModal);
    const openTransactionHistoryModal = useCallback(()=>{
        dispatchPushExclusiveTransactionHistoryModal(deviation);
    }, [
        deviation,
        dispatchPushExclusiveTransactionHistoryModal
    ]);
    const handleClick = useBatchedCallback(openTransactionHistoryModal, onClick);
    return /*#__PURE__*/ React.createElement(TextButton, _object_spread({
        variant: "main",
        size: "small",
        icon: ResaleIcon,
        postfix: ArrowRightIcon,
        onClick: handleClick
    }, rest), t('sidebar.exclusives.tradeCount', {
        count
    }));
};
TradeCount.displayName = 'TradeCount';
export default TradeCount;

//# sourceMappingURL=TradeCount.js.map